import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { verifyFaceAPI } from "../../../Services/ApiTestService/apiTestService";
import { Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { MdDelete } from "react-icons/md";
import { useService } from "../../../context/ServiceContext";


const FaceApi = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [faceMatchData, setfaceMatchData] = useState({});
  const [showFaceMatchData , setShowFaceMatchData] = useState(false)
  const [errors, setErrors] = useState({});
  const [profileData, setProfileData] = useState({});
  const { serviceName } = useService();

  const [person, setPerson] = useState(null);
  const [preview, setPreview] = useState(null);
  const [cardData, setCardData] = useState(null);
  const [cardPreview, setCardPreview] = useState(null);



  // Fetch profile data on mount
  useEffect(() => { 
    const fetchProfileData = async () => {
      try {
        setIsLoading(true);
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data:", error);
        showErrorToast("Failed to fetch profile data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfileData();
  }, []);


const validateForm = (person , cardData) => {
  const errors = {};
  if (!person) {
    errors.person = "Image is required.";
  } 

  if (!cardData) {
    errors.cardData = "Card is required.";
  } 
  return errors;
};


  
const handleSubmit = async () => {
  const validationErrors = validateForm(person , cardData);
  setErrors(validationErrors);
  if (Object.keys(validationErrors).length > 0) return;
 // console.log(person , cardData)

  try {
    setIsLoading(true);

    const response = await verifyFaceAPI({
      api_id: profileData?.user_id,
      api_key: profileData?.api_key,
      token_id: profileData?.token_id,
      personFile : person,
      cardFile : cardData
    });

   // console.log("response" , response)

    const statusCode = response?.status?.code || response?.status;

    if (statusCode === 200) {
   
const rcData = response?.data;

if (rcData && typeof rcData === "object") {
  setfaceMatchData(rcData);
  setShowFaceMatchData(true);

  if (rcData.is_same_face) {
    showSuccessToast("Face verified successfully.");
  } else {
    showErrorToast("Face does not match the ID card.");
  }

  setPerson(null);
  setCardData(null);
  setErrors({});
} else {
  showErrorToast("Unexpected API format.");
}

}

    else if (statusCode === 422) {
      showErrorToast(response.data.message || "Invalid format");
    } 
    
    else if (statusCode === 500) {
      showErrorToast(response.data.message || "Server error");
    } 
    
    else {
      showErrorToast(response.status?.message || "Something went wrong");
    }

  } catch (error) {
    console.error("Face API Error:", error);
    showErrorToast("Failed to verify face.");
  } finally {
    setIsLoading(false);
  }
};


  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading={serviceName} />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:ml-80 ml-0 p-4">
       
      <div className="col-span-2 md:col-span-6 flex justify-end">
  <Link
    to="/TestMaster"
    className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
  >
    <span>Go Back</span>
    <IoArrowBackCircleOutline size={24} />
  </Link>
</div>

      {/* input box + verify button */}
      <div className="flex flex-col">

        {/* file input box */}

        <div className="flex gap-6 w-[620px] -ml-[30px]">

                {/* start person image drag and drop */}
                  <div className="w-60 h-60 p-4 bg-white shadow-sm rounded-md">
                                  <div
                                      className="flex flex-col items-center justify-center h-full border-2 border-dashed border-blue-300 rounded-md cursor-pointer hover:bg-blue-50 transition"
                                      onDragOver={(e) => e.preventDefault()}
                                      onDrop={(e) => {
                                      e.preventDefault();
                                      const file = e.dataTransfer.files[0];

                                      if (!file || !file.type.startsWith("image/")) {
                                          return;
                                      }

                                      setPerson(file);
                                      setPreview(URL.createObjectURL(file));
                                      }}
                                      onClick={() => document.getElementById("personHiddenInput").click()}
                                  >
                                      {!preview ? (
                                      <>
                                          <p className="text-sm text-gray-600 text-center">
                                          Drag & drop 1st image here
                                          </p>
                                          <p className="text-xs text-gray-400 mt-1">or click to browse</p>
                                      </>
                                      ) : (
                                        <>
                                        <div className="relative w-44 h-44">
                                          <img
                                              src={preview}
                                              alt="Person Preview"
                                              className="w-full h-full object-cover rounded-md"
                                          />
                                          <div>

                                          <MdDelete size={16} className="absolute right-0 top-1 z-10 hover:text-red-500" onClick={(e) => {
                                            e.stopPropagation();
                                            setPerson(null);
                                            setPreview(null);
                                          }}/>
                                          </div>
                                        </div>
                                        </>
                                      
                                      )}
                                  </div>

                                  {/* Hidden file input (for click fallback) */}
                                  <input
                                      type="file"
                                      id="personHiddenInput"
                                      accept="image/*"
                                      hidden
                                      onChange={(e) => {
                                      const file = e.target.files[0];
                                      if (!file) return;

                                      setPerson(file);
                                      setPreview(URL.createObjectURL(file));
                                      }}
                                  />

                                  {errors.person && (
                                      <p className="text-xs text-red-500 mt-1">{errors.person}</p>
                                  )}
                  </div>
                {/* end person image drag and drop */}

                {/* start card image drag and drop */}
                    <div className="w-60 h-60 p-4 bg-white shadow-sm rounded-md">
                                  <div
                                      className="flex flex-col items-center justify-center h-full border-2 border-dashed border-blue-300 rounded-md cursor-pointer hover:bg-blue-50 transition"
                                      onDragOver={(e) => e.preventDefault()}
                                      onDrop={(e) => {
                                      e.preventDefault();
                                      const file = e.dataTransfer.files[0];

                                      if (!file || !file.type.startsWith("image/")) {
                                          return;
                                      }

                                      setCardData(file);
                                      setCardPreview(URL.createObjectURL(file));
                                      }}
                                      onClick={() => document.getElementById("cardHiddenInput").click()}
                                  >
                                      {!cardPreview ? (
                                      <>
                                          <p className="text-sm text-gray-600 text-center">
                                          Drag & drop 2nd image here
                                          </p>
                                          <p className="text-xs text-gray-400 mt-1">or click to browse</p>
                                      </>
                                      ) : (
                                        <div className="w-44 h-44 relative">
                                          <img
                                              src={cardPreview}
                                              alt="Card Preview"
                                              className="w-full h-full object-cover rounded-md"
                                          />
                                          <MdDelete size={16} className="absolute top-1 right-0 z-10 hover:text-red-500" onClick={(e) => {
                                            e.stopPropagation();
                                            setCardData(null);
                                            setCardPreview(null);
                                          }}/>

                                        </div>
                                      )}
                                  </div>

                                  {/* Hidden file input (for click fallback) */}
                                  <input
                                      type="file"
                                      id="cardHiddenInput"
                                      accept="image/*"
                                      hidden
                                      onChange={(e) => {
                                      const file = e.target.files[0];
                                      if (!file) return;

                                      setCardData(file);
                                      setCardPreview(URL.createObjectURL(file));
                                      }}
                                  />

                                  {errors.cardData && (
                                      <p className="text-xs text-red-500 mt-1">{errors.cardData}</p>
                                  )}
                    </div>
                {/* end card image drag and drop */}

        </div>

        {/* verify Button */}
        <div>
                  <Button
                    type="button"
                    className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2 md:ml-[190px]"
                    id="verifyRC"
                    name="verifyRC"
                    text="Verify"
                    onClick={handleSubmit}
                  />
        </div>
            
      </div>

    </div>

    {/* instructions how to use this face match API */}
    <div class="max-w-2xl mx-auto p-2 bg-white rounded-2xl shadow-lg mt-3 mb-6">
      <h2 class="text-xl font-bold text-center text-gray-800 mb-2">Face Match Verification Steps</h2>

      <ol class="list-decimal list-inside text-gray-700 space-y-1">
          <li>Upload your clear 1st image.</li>
          <li>Upload your clear 2nd image.</li>
          <li>Click on "Verify" to match the face of the person with the images provided.</li>
      </ol>

      <div class="mt-2">
          <h3 class="text-xl font-semibold text-gray-800 mb-2">Important Notes:</h3>
          <ul class="list-disc list-inside text-gray-600 space-y-1">
          <li>Do not refresh the page during the verification process.</li>
          </ul>
      </div>
    </div>

{showFaceMatchData && faceMatchData && typeof faceMatchData === "object" && (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 px-4">

    {/* Face Match Summary */}
    <div className="bg-gradient-to-br from-green-50 to-white border border-green-200 rounded-2xl shadow-xl p-4">
      <h3 className="text-green-800 font-semibold text-xl">
        Face Verification Result
      </h3>

      <div className="text-sm text-gray-700 mt-3 space-y-1">
        <p>
          <strong>Status:</strong>{" "}
          {faceMatchData.is_same_face ? (
            <span className="text-green-600 font-semibold">Matched</span>
          ) : (
            <span className="text-red-600 font-semibold">Not Matched</span>
          )}
        </p>

        <p>
          <strong>Match Confidence:</strong>{" "}
          {(faceMatchData.same_face_confidence * 100).toFixed(2)}%
        </p>

        <p>
          <strong>Person Image:</strong>{" "}
          {faceMatchData.person_image_correctly_identified ? "Valid" : "Invalid"}
        </p>

        <p>
          <strong>Card Image:</strong>{" "}
          {faceMatchData.card_image_correctly_identified ? "Valid" : "Invalid"}
        </p>

        <p>
          <strong>Person Image Blur:</strong>{" "}
          {faceMatchData.is_person_image_blurry ? "Yes" : "No"}
        </p>

        <p>
          <strong>Card Image Blur:</strong>{" "}
          {faceMatchData.is_card_image_blurry ? "Yes" : "No"}
        </p>
      </div>
    </div>

    {/* Raw JSON Preview */}
    <div className="bg-gradient-to-br from-blue-50 to-white border border-blue-200 rounded-2xl shadow-xl p-4">
      <h3 className="text-blue-800 font-semibold text-xl mb-2">
        API Response (Raw)
      </h3>

      <pre className="bg-gray-100 p-3 rounded text-xs overflow-y-auto max-h-[250px]">
        {JSON.stringify(faceMatchData, null, 2)}
      </pre>
    </div>
  </div>
)}



    </>
  );
};

export default FaceApi;
